export default [{
        text: 'Survey Date',
        value: 'surveyDate'
    },
    {
        text: 'User',
        value: 'user'
    },
    {
        text: 'Asset Id',
        value: 'assetNo'
    },
    {
        text: 'Address',
        value: 'address'
    },
    {
        text: 'Project Reference',
        value: 'projectReference'
    },
    {
        text: 'Type',
        value: 'type'
    }
]
